export const LocalStorage_keys = {
    USER_KEY: 'user',
    LANG_KEY: 'lang',
    JWT_KEY: 'jwt',
};
